import { addToast } from '@heroui/react';

export const toast = {
  success: (msg: unknown) => addToast({ title: String(msg ?? ''), color: 'success' }),
  error: (msg: unknown) => addToast({ title: String(msg ?? ''), color: 'danger' }),
  warning: (msg: unknown) => addToast({ title: String(msg ?? ''), color: 'warning' }),
};